import React from "react";
import styled from "styled-components";

import { SkyLightStateless } from "react-skylight";
import { styles } from "../menu/styles";
import Header from "../header";
import { PrintComponent } from "./PrintComponent";
import { canPrintPaper } from "../pages/paper/paper-display";

const HeaderContainer = styled.div`
  display: flex;
`;

export const PrintDialog = ({ paper, companyId, companyName, printSettings, title, onClose }) => {
  if (!canPrintPaper(paper, companyId)) {
    return null;
  }
  return (
    <div>
      <SkyLightStateless
        isVisible={true}
        dialogStyles={styles.defaultDialogStyles}
        onCloseClicked={onClose}
        onOverlayClicked={onClose}
        title={
          <HeaderContainer>
            <Header title={title || "Print"} />
          </HeaderContainer>
        }
      >
        <PrintComponent paper={paper} companyName={companyName} printSettings={printSettings} />
      </SkyLightStateless>
    </div>
  );
};
